<div>
  <h2>{{'mantenimientoDesignaciones.titulo' | translate}}</h2>
  <section class="filters-framed" *ngIf="filtersVisible">
    <form [formGroup]="filtersForm" [ngClass]="{'show-error': showError}">
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'global.pais' | translate}}</label>
        <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')"
          [placeHolder]="false"></app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'global.provincia' | translate}}</label>
        <app-filterable-list [itemsList]="provincias" [selectedItem]="filtersForm.get('provincia')"
          [disabled]="disabledProvincias" [placeHolder]="false"></app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'global.municipio' | translate}}</label>
        <app-filterable-list [itemsList]="municipios" [selectedItem]="filtersForm.get('municipio')"
          [disabled]="disabledMunicipios" [placeHolder]="false"></app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'mantenimientoDesignaciones.filters.denominacion' | translate}}</label>
        <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
          [disabled]="disabledDenominaciones" [placeHolder]="false"></app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'mantenimientoDesignaciones.filters.marca' | translate}}</label>
        <app-filterable-list [itemsList]="marcas" [selectedItem]="filtersForm.get('marca')" [disabled]="disabledMarcas"
          [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'mantenimientoDesignaciones.filters.campanya' | translate}}</label>
        <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')"
          [disabled]="disabledCampanyas" [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'mantenimientoDesignaciones.filters.etiquetador' | translate}}</label>
        <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')"
          [disabled]="disabledEtiquetadores" [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ?'entry-3-small' : 'entry-5'">
        <label>{{'global.almacen' | translate}}</label>
        <app-filterable-list [itemsList]="almacenes" [selectedItem]="filtersForm.get('almacen')"
          [disabled]="disabledAlmacenes" [placeHolder]="false"></app-filterable-list>
      </div>
      <!-- <div class="entry-3">
                <label>{{'global.cultivo' | translate}}</label>
                <app-filterable-list [itemsList]="cultivos" [selectedItem]="filtersForm.get('cultivo')" [disabled]="disabledCultivos">
                </app-filterable-list>
            </div> -->
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'mantenimientoDesignaciones.filters.productor' | translate}}</label>
        <input type="text" formControlName="productor">
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'global.finca' | translate}}</label>
        <input type="text" formControlName="finca">
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
        <label>{{'global.fecha.inicio' | translate}}</label>
        <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}"
          formControlName="fechaInicio" (click)="fechaInicio.open()">
        <mat-datepicker #fechaInicio></mat-datepicker>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
        <label>{{'global.fecha.fin' | translate}}</label>
        <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}"
          formControlName="fechaFin" (click)="fechaFin.open()">
        <mat-datepicker #fechaFin></mat-datepicker>
      </div>
      <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <checkbox [id]="'fincaDePrueba'" [initialStatus]="''" [initialRefresh]="refreshCheckboxPrueba"
          [label]="'mantenimientoDesignaciones.filters.fincaPrueba'" (refresh)="this.refreshCheckboxPrueba = false"
          (formValue)="this.filtersForm.get('fincaDePrueba')?.patchValue($event)"
          (pristine)="pristineCheckbox('fincaDePrueba', $event)"></checkbox>
      </div>
      <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <checkbox [id]="'finalizada'" [initialStatus]="''" [initialRefresh]="refreshCheckboxFinalizada"
          [label]="'mantenimientoDesignaciones.filters.finalizada'" (refresh)="this.refreshCheckboxFinalizada = false"
          (formValue)="this.filtersForm.get('finalizada')?.patchValue($event)"
          (pristine)="pristineCheckbox('finalizada', $event)"></checkbox>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
    </form>
  </section>
  <section class="filters-buttons">
    <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
      title="{{'global.filtros.abrir' | translate}}">
      <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
    </button>
    <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
      (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
      <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
    </button>
    <button *ngIf="filtersVisible" class="secondary"
      [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
      title="{{'global.filtros.limpiar' | translate}}">
      <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
    </button>
    <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
      title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
      <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
    </button>
  </section>
  <section class="export-buttons">
    <i class="fas fa-file-pdf" [ngClass]="{'disabled': !designaciones|| (designaciones && designaciones.length < 1)}"
      (click)="exportPdfOrCsv('pdf')" title="{{'titles.exportarPDF' | translate}}"></i>
    <i class="fas fa-file-csv" [ngClass]="{'disabled': !designaciones || (designaciones && designaciones.length < 1)}"
      (click)="exportPdfOrCsv('csv')" title="{{'titles.exportarCSV' | translate}}"></i>
    <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
  </section>
  <content class="tabs">
    <form>
      <h3>{{'mantenimientoDesignaciones.datosDesignaciones.titulo' | translate}}</h3>
      <section class="info-framed" *ngIf="totalesDesignaciones">
        <div class="entry-4" *ngIf="role !== 'Etiquetador'">
          <label>{{'mantenimientoDesignaciones.datosDesignaciones.aforo' | translate}}</label>
          <span>{{totalesDesignaciones.aforo ? (totalesDesignaciones.aforo | number : '1.2-2' : defaultLanguage) :
            0}}</span>
        </div>
        <div class="entry-4">
          <label>{{'mantenimientoDesignaciones.datosDesignaciones.designados' | translate}}</label>
          <span>{{totalesDesignaciones.kgDesignados ? (totalesDesignaciones.kgDesignados | number : '1.2-2' :
            defaultLanguage) : 0}}</span>
        </div>
      </section>
      <section class="info-framed" *ngIf="!totalesDesignaciones">
        <div [ngClass]="this.isSmallScreen ? 'entry-5-small' : 'entry-5'">
          <label>{{'mantenimientoDesignaciones.datosDesignaciones.calculandoTotales' | translate}}</label>
        </div>
      </section>
    </form>
    <div class="table-wrapper">
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th class="icon-3"></th>
              <th class="icon"></th>
              <th class="icon"></th>
              <th class="icon">{{'mantenimientoDesignaciones.table.estado' | translate}}</th>
              <th class="date sortable" (click)="toOrderBy('x=> x.fecha', 3)">
                {{'mantenimientoDesignaciones.table.fecha' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.fecha')"></i>
                </div>
              </th>
              <th class="string sortable" (click)="toOrderBy('x=> Cultivo.Campanya.PaisDenominacion.Denominacion.Des', 6)">
                {{'mantenimientoDesignaciones.table.denominacion' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> Cultivo.Campanya.PaisDenominacion.Denominacion.Des')"></i>
                </div>
              </th>
              <th class="string sortable" (click)="toOrderBy('x=> x.Etiquetador.Des', 7)">
                {{'mantenimientoDesignaciones.table.etiquetador' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Etiquetador.Des')"></i>
                </div>
              </th>
              <th class="string sortable" (click)="toOrderBy('x=> x.Cultivo.Finca.Des', 9)">
                {{'global.finca' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Cultivo.Finca.Des')"></i>
                </div>
              </th>
              <th class="string sortable" (click)="toOrderBy('x=> x.Cultivo.CultivosProductor.First().Productor.Des', 10)">
                {{'mantenimientoDesignaciones.table.productor' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Cultivo.CultivosProductor.First().Productor.Des')"></i>
                </div>
              </th>
              <th class="string sortable" (click)="toOrderBy('x=> x.Cultivo.Finca.Municipio.Des', 11)">
                {{'global.municipio' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Cultivo.Finca.Municipio.Des')"></i>
                </div>
              </th>
              <th class="number sortable"
                *ngIf="this.role === 'Administrador' || this.claims.includes('D_DSG_AforoVisible')"
                (click)="toOrderBy('x=> x.CultivoMarca == null ? x.Cultivo.Aforo : x.CultivoMarca.Aforo', 12)">
                {{'mantenimientoDesignaciones.table.aforo' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.CultivoMarca == null ? x.Cultivo.Aforo : x.CultivoMarca.Aforo')"></i>
                </div>
              </th>
              <th class="number sortable" (click)="toOrderBy('x=> x.cantidad', indexOrder)">
                {{'mantenimientoDesignaciones.table.designado' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.cantidad')"></i>
                </div>
              </th>
              <th class="action">
                <i class="fas fa-plus" *ngIf="this.role === 'Administrador' || this.claims.includes('DSG_Ins')"
                  (click)="create()" title="{{'mantenimientoDesignaciones.tituloNew' | translate}}"></i>
              </th>
            </tr>
          </thead>
          <tbody *ngFor="let designacion of designaciones; let i=index; trackBy: trackByDesignacionId">
            <tr (click)="showDetails(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}" style="cursor: pointer;">
              <td class="icon-3">
                <i *ngIf="designacion.fincaDePrueba" class="fa-solid fa-house-circle-check fa-1x"
                  title="{{'titles.fincaDePrueba' | translate}}"></i>
                <i *ngIf="designacion.desMarca" class="fa-solid fa-trademark fa-1x" title="{{designacion.desMarca}}"></i>
                <i *ngIf="designacion.esEtqDigital" class="fa-solid fa-file fa-1x"
                  title="{{'global.etiquetaDigital' | translate}}"></i>
              </td>
              <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                  title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
              </td>
              <td class="icon">
                <a *ngIf="(this.claims.includes('D_EC_InfoBlockchainVisible') && (designacion && designacion.designacionVechain?.existeRegBlockchain)) || (this.role === 'Administrador' && (designacion && designacion.designacionVechain?.existeRegBlockchain))" href="{{designacion.designacionVechain?.txIdExplore}}" target="_blank">
                  <i class="fas fa-circle-nodes" title="{{'global.blockchain.verBlockchain' | translate}}" style="cursor: pointer;"></i>
                </a>
              </td>
              <td class="icon">
                <i *ngIf="designacion.finalizada" style="color:red" class="fas fa-sm fa-power-off fa-1x"
                  title="{{'titles.designacionFinalizada' | translate}}"></i>
                <i *ngIf="!designacion.impresionAutorizada" class="fas fa-sm fa-lock fa-1x"
                  title="{{'titles.impresionDeshabilitada' | translate}}"></i>
                <i *ngIf="!designacion.reimpresionAutorizada" class="fa-lg icon-rotate-right_cancel fa-1x"
                  title="{{'titles.reimpresionDeshabilitada' | translate}}"></i>
              </td>
              <td class="date">{{designacion.fecha | date: 'shortDate' : undefined : defaultLanguage}}</td>
              <td class="string">{{designacion.desDenominacion}}</td>
              <td class="string">{{designacion.desEtiquetador}}</td>
              <td class="string">{{designacion.desFinca}}</td>
              <td class="string">{{designacion.desProductor}}</td>
              <td class="string">{{designacion.desMunicipio}}</td>
              <td class="number" *ngIf="this.role === 'Administrador' || this.claims.includes('D_DSG_AforoVisible')">
                {{designacion.aforoCultivo | number : '1.2-2': defaultLanguage}}</td>
              <td class="number">{{designacion.cantidad | number : '1.2-2': defaultLanguage}}</td>
              <td class="multi-actions-subtable">
                <i class="fas fa-stream" app-click-stop-propagation
                  *ngIf="this.role === 'Administrador' || this.claims.includes('D_DSG_AlmacenList')"
                  (click)="showSection(i)"
                  title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                <i class="fas fa-pencil-alt" app-click-stop-propagation
                  *ngIf="this.role === 'Administrador' || this.claims.includes('DSG_Upd')"
                  [ngClass]="{'disabled': !designacion.registroEditable}" (click)="update(designacion)"
                  title="{{'titles.editar' | translate}}"></i>
                <i class="far fa-trash-alt" app-click-stop-propagation
                  *ngIf="this.role === 'Administrador' || this.claims.includes('DSG_Del')"
                  [ngClass]="{'disabled': (designacion.registroEnUso || !designacion.registroEditable)}"
                  (click)="askDelete(designacion)" title="{{'titles.eliminar' | translate}}"></i>
              </td>
            </tr>
            <tr *ngIf="dropdownInfo === i">
              <td colspan="14">
                <div class="detail">
                  <div class="title">{{'global.masInformacion' | translate}}</div>
                  <div class="block-inline">
                    <label>{{'mantenimientoDesignaciones.table.id' | translate}}</label>
                    <p>
                      {{designacion.id}}
                    </p>
                  </div>
                  <div class="block-inline">
                    <label>{{'mantenimientoDesignaciones.table.marca' | translate}}</label>
                    <p>
                      {{designacion.desMarca}}
                    </p>
                  </div>
                  <div class="block-inline">
                    <label>{{'mantenimientoDesignaciones.table.licencia' | translate}}</label>
                    <p>
                      {{designacion.nLicencia}}
                    </p>
                  </div>
                  <div class="block-inline">
                    <label>{{'global.fecha.insercionShort' | translate}}</label>
                    <p>
                      {{designacion.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}
                    </p>
                  </div>
                  <div class="block-inline">
                    <label>{{'global.fecha.actualizacionShort' | translate}}</label>
                    <p>
                      {{designacion.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}
                    </p>
                  </div>
                  <div class="block-inline">
                    <label></label>
                    <p></p>
                  </div>
                  <div class="block-inline">
                    <label></label>
                    <p></p>
                  </div>
                  <div class="block-inline">
                    <label></label>
                    <p></p>
                  </div>
                </div>
              </td>
            </tr>
            <!-- Campos blockchain -->
            <tr *ngIf="(blockchainInfo === i && (designacion && designacion.designacionVechain?.existeRegBlockchain) && this.claims.includes('D_EC_InfoBlockchainVisible')) || (blockchainInfo === i && (designacion && designacion.designacionVechain?.existeRegBlockchain) && this.role === 'Administrador')">
              <td colspan="14">
                <div class="detail">
                  <div class="title">{{'global.blockchain.informacion.titulo' | translate}}</div>
                  <div class="block-inline">
                    <label>{{'global.blockchain.informacion.blockchain' | translate}}</label>
                    <p>{{designacion.designacionVechain?.blockchain}}</p>
                  </div>
                  <div class="block-inline gap">
                    <label>{{'global.blockchain.informacion.fechaRegistro' | translate}}</label>
                    <p>{{designacion.designacionVechain?.fechaRegistro | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
                  </div>
                  <div class="block-inline gap nowrap">
                    <label>{{'global.blockchain.informacion.input' | translate}}</label>
                    <p>{{designacion.designacionVechain?.textoHash}}</p>
                  </div>
                  <div class="block-inline">
                    <label></label>
                    <p></p>
                  </div>
                  <div class="block-inline gap nowrap">
                    <label>{{'global.blockchain.informacion.idCripto' | translate}}</label>
                    <p>{{designacion.designacionVechain?.txId}}</p>
                  </div>
                  <div class="block-inline">
                    <label></label>
                    <p></p>
                  </div>
                  <div class="block-inline">
                    <label></label>
                    <p></p>
                  </div>
                  <div class="block-inline">
                    <label></label>
                    <p></p>
                  </div>
                  <div class="block-inline gap nowrap">
                    <label>{{'global.blockchain.informacion.hash' | translate}}</label>
                    <p>{{designacion.designacionVechain?.hash}}</p>
                  </div>
                  <div class="block-inline">
                    <label></label>
                    <p></p>
                  </div>
                  <div class="block-inline">
                    <label></label>
                    <p></p>
                  </div>
                  <div class="block-inline">
                    <label></label>
                    <p></p>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="dropdownSection === i">
              <td colspan="15">
                <section class="tabs">
                  <ul>
                    <li [ngClass]="{'active': pestanaActiva[i] === 1}" (click)="showAlmacenes(i)">
                      {{'mantenimientoEtiquetadores.table.almacenes' | translate}}</li>
                  </ul>
                  <content>
                    <app-dsg-almacenes *ngIf="pestanaActiva[i] === 1" [etiquetadorId]="designacion.etiquetadorId"
                      [designacionId]="designacion.id" (pushMessage)="pushMessage($event)"></app-dsg-almacenes>
                  </content>
                </section>
              </td>
            </tr>
          </tbody>
          <tfoot *ngIf="!designaciones || (designaciones && designaciones.length < 1)">
            <tr>
              <td colspan="13">
                {{ 'global.noContent' | translate}}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <app-paginator *ngIf="designaciones && designaciones.length > 0" [itemsPerPage]="itemsPerPage"
      [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
      (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
    </app-paginator>
    <app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
  </content>
</div>
<div class="modal" *ngIf="deleteModal">
  <div class="modal-content">
    <header>
      <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
    </header>
    <content>
      <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
    </content>
    <footer>
      <button class="secondary" (click)="close()">{{ 'global.cancelar' | translate }}</button>
      <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
    </footer>
  </div>
</div>
<div class="modal" *ngIf="newModal">
  <div class="modal-content">
    <header>
      <h4>{{'mantenimientoDesignaciones.tituloNew' | translate}}</h4>
    </header>
    <app-mantenimientoDesignaciones-new-edit (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
    </app-mantenimientoDesignaciones-new-edit>
  </div>
</div>
<div class="modal" *ngIf="editModal">
  <div class="modal-content">
    <header>
      <h4>{{'mantenimientoDesignaciones.tituloEdit' | translate}}</h4>
    </header>
    <app-mantenimientoDesignaciones-edit [designacionId]="designacionId" (refresh)="refresh($event)"
      (mensaje)="pushMessage($event)">
    </app-mantenimientoDesignaciones-edit>
  </div>
</div>
